import processSavingsTypeEndOfTurn from "./process_savings_type_end_of_turn";
import calculateSavingsTax from "./calculate_savings_tax";
import calculateRetirementTransferTax from "./calculate_retirement_transfer_tax";

export const moveFromCashToSavings = (savingsArr, gameDate, assetTable, currentPriceArr, companyMatchRate,
    gameID, savingsTypeTranArr) => {
    let savingsCashAmt = 0;
    let taxAmt = 0;
    let taxRate = 0;
  
    for (let i=0; i<savingsArr.length; i++){
        let tranNbr = savingsArr[i].savingTotals.nbrTrans;
        let tranArr = [];
        if (savingsArr[i].closedDate === ""){
            let currentPrice = 0;
            const savingsObj = savingsArr[i];
            if (savingsObj.savingsClass === "retirement"){
                currentPrice = 
                    currentPriceArr.find(elem => elem.retirementType === savingsArr[i].savingsType).currentPrice;
            }
            const savingsUpdtInfo = processSavingsTypeEndOfTurn(savingsArr[i], gameDate, currentPrice, 
               companyMatchRate, tranArr, tranNbr);
            savingsArr[i] = savingsUpdtInfo.savingsObj;
            savingsCashAmt += +savingsUpdtInfo.cashChg;
            tranNbr = savingsUpdtInfo.tranNbr;
           
        }
        const gameDateArr = gameDate.split("-");
        const gameYear = gameDateArr[0];
        const gameMonth = gameDateArr[1];
        if (gameMonth === "12" &&
            savingsArr[i].yearArr.length > 0 ){
            let maxIndx = savingsArr[i].yearArr.length - 1;
            const yearArr = savingsArr[i].yearArr;
            // only process if the last year in the yearArr table is current year
            if (yearArr[maxIndx].year === gameYear){
                if(savingsArr[i].savingsClass === "bank" &&
                    +yearArr[maxIndx].totalInterest > 100){
                    const interestEarned = +yearArr[maxIndx].totalInterest;
                    const taxTranNbr = savingsArr[i].taxHistoryArr.length;
                    const taxAmtObj = calculateSavingsTax(interestEarned, assetTable, 
                        gameDate, taxRate, taxTranNbr);
                    taxAmt += +taxAmtObj.taxAmt;
                    taxRate = taxAmtObj.taxRate;
                    savingsArr[i].taxHistoryArr.push(taxAmtObj.taxTran);
                }
                if (savingsArr[i].savingsClass === "retirement"){
                    if (yearArr[maxIndx].transferAmt &&
                        +yearArr[maxIndx].transferAmt > 0 ){
                            const transferAmt = yearArr[maxIndx].transferAmt;
                            const transferFee = yearArr[maxIndx].penaltyAmt;
                            const taxTranNbr = savingsArr[i].taxHistoryArr.length;
                            const taxAmtObj = calculateRetirementTransferTax(transferAmt,
                                transferFee, assetTable, gameDate, taxTranNbr);
                            taxAmt += +taxAmtObj.taxAmt;
                            taxRate = taxAmtObj.taxRate;
                            savingsArr[i].taxHistoryArr.push(taxAmtObj.taxTran);
                    }
                }
            }
        }
        const savingArrIndx = savingsTypeTranArr.findIndex(elem => elem.savingsType === savingsArr[i].savingsType);
        if (savingArrIndx === -1){
            const savingsTypeTranObj = {gameID: gameID, 
                savingsType: savingsArr[i].savingsType, tranArr: tranArr};
            savingsTypeTranArr.push(savingsTypeTranObj);
        }else{
            const currentTranArr = savingsTypeTranArr[savingArrIndx].tranArr;
            savingsTypeTranArr[savingArrIndx].tranArr = currentTranArr.concat(tranArr);
        }
        savingsArr[i].savingTotals.nbrTrans = tranNbr;
    }
    let savingsInfoObj = {savingsArr: savingsArr, cashAmt: savingsCashAmt, taxAmt: taxAmt, 
        savingsTranArr: savingsTypeTranArr};
    
    return savingsInfoObj;
   
}





